(() => {
  const KEY = 'cdg-consent-v1';
  const queue = window.cdgTrack?.q || [];

  function consent() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || 'null') || {};
    } catch (error) {
      return {};
    }
  }

  function centsToReais(cents) {
    return Number((Number(cents || 0) / 100).toFixed(2));
  }

  function itemFromVariant(product, variant, quantity) {
    return {
      item_id: String(variant.sku || variant.id),
      item_name: product.title,
      item_variant: variant.public_title || variant.title || '',
      price: centsToReais(variant.price),
      quantity: Number(quantity || 1)
    };
  }

  function ga(name, params) {
    if (!consent().analytics) return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ecommerce: params });
  }

  function meta(name, params) {
    if (!consent().marketing || typeof window.fbq !== 'function') return;
    window.fbq('track', name, params);
  }

  function track(name, payload) {
    if (window.cdgTracking?.themeEvents === false) return;
    const params = payload || {};
    switch (name) {
      case 'view_item':
        ga('view_item', params);
        meta('ViewContent', {
          content_ids: params.items?.map((item) => item.item_id),
          content_type: 'product',
          value: params.value,
          currency: params.currency
        });
        break;
      case 'search':
        ga('search', { search_term: params.search_term });
        meta('Search', { search_string: params.search_term });
        break;
      case 'add_to_cart':
        ga('add_to_cart', params);
        meta('AddToCart', {
          content_ids: params.items?.map((item) => item.item_id),
          content_type: 'product',
          value: params.value,
          currency: params.currency
        });
        break;
      case 'begin_checkout':
        ga('begin_checkout', params);
        meta('InitiateCheckout', {
          value: params.value,
          currency: params.currency,
          num_items: params.items?.reduce((sum, item) => sum + Number(item.quantity || 1), 0)
        });
        break;
      default:
        ga(name, params);
    }
  }

  function bootPageEvents() {
    document.querySelectorAll('[data-cdg-pdp]').forEach((root) => {
      const jsonEl = root.querySelector('[data-cdg-product-json]');
      if (!jsonEl) return;
      try {
        const product = JSON.parse(jsonEl.textContent);
        const variant =
          product.variants.find((item) => String(item.id) === String(root.querySelector('[data-cdg-variant-id]')?.value)) ||
          product.variants[0];
        if (!variant) return;
        track('view_item', {
          currency: 'BRL',
          value: centsToReais(variant.price),
          items: [itemFromVariant(product, variant, 1)]
        });
      } catch (error) {
        console.warn('CDG track view_item', error);
      }
    });

    const searchRoot = document.querySelector('[data-cdg-search-term]');
    if (searchRoot?.dataset.cdgSearchTerm) {
      track('search', { search_term: searchRoot.dataset.cdgSearchTerm });
    }
  }

  window.cdgTrack = track;
  window.cdgTrackItem = itemFromVariant;
  queue.forEach((args) => track(args[0], args[1]));

  if (document.querySelector('[data-cdg-consent]')) {
    document.addEventListener('cdg:tracking-ready', bootPageEvents, { once: true });
  } else {
    bootPageEvents();
  }
})();
